<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in adList" :key="index">
        <a @click="jump(item.jumpType, item.bizId, item.url)">
          <img :bookid="0" :booktitle="0" :chapternum="0" :imgpath="item.imgPath" :zoom="2000" v-lazy="require('../../assets/images/loading_ho.jpg')">
        </a>
      </div>
    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
  import Swiper from '../../assets/js/swiper'
  import {getImg} from "../../services/urlService";
  import {getImgPlaceholder} from "../../services/urlService";

  export default {
    name: "swiper",
    props: ['adList'],
    data() {
      return {
        list: []
      }
    },
    methods: {
      jump(jumpType, id, openUrl) {
        this.$router.isBack = false;
        if (jumpType === -1){
          window.location.href=openUrl;
        }else if (jumpType === -2){
          window.open(openUrl,"_blank")
        } else if (jumpType === 2){
          this.$router.push(`/book/${id}`)
        } else if (jumpType === 3) {
          this.$router.push(`/purchase`)
        }
      }
    },
    mounted() {
      new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 12500,
        autoplayDisableOnInteraction: false,
        observer:true
      });
    }
  }
</script>

<style scoped>
  @import '../../assets/css/swiper.css';
</style>



// WEBPACK FOOTER //
// src/components/share/swiper.vue